import React, { useEffect, useState } from 'react'
import Select from "react-select";
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang';

function SelectDropDown({ arrayofnumber, multi, options, defaultvalue, placeholder, disable, value1, varr, setVarr, setStateCustom, loadingList }) {
    const { langLocal } = AbstructVar()
    const { translate } = AbstructLang()
    useEffect(() => {
        if (defaultvalue && defaultvalue?.value) {
            if (setVarr) { setVarr(defaultvalue?.value) }
            else { setStateCustom(varr, defaultvalue?.value) }
        }
    }, [])
    let formattedDefaultValue = defaultvalue && defaultvalue?.value
        ? [{ value: defaultvalue?.value?.toString(), label: defaultvalue?.label }]
        : [];
    const customStyles = {
        control: (provided) => ({
            ...provided,
            borderRadius: "4px",
            fontSize: "13px",
            textAlign: `${langLocal === 'ar' ? "right" : "left"}`
        }),
        menu: (provided, state) => ({
            ...provided,
            height: "auto",
            touchAction: 'pan-y'
        }),
        menuList: (provided) => ({
            ...provided,
            touchAction: 'pan-y'
        })
    };
    return (
        <Select
            isMulti={multi}
            closeMenuOnSelect={false}
            options={options}
            defaultValue={multi  ? defaultvalue : formattedDefaultValue}
            isDisabled={disable ? true : false}
            isClearable={true}
            isSearchable={true}
            loadingMessage={() => "Loading ..."}
            isLoading={loadingList}
            placeholder={placeholder ? placeholder : translate('select')}
            value={value1 === "" ? "" : options && options?.find(option => option.value === value1)}
            className={"basic-multi-select"}
            classNamePrefix="select"
            hideSelectedOptions={false}
            styles={customStyles}
            onChange={(selectedOptions) => {
                if (arrayofnumber) {
                    setVarr(
                        selectedOptions.map((option) => {
                            return option?.value

                        }))
                }
                else if (setVarr) { setVarr(selectedOptions?.value) }
                else { setStateCustom(varr, selectedOptions?.value) }
            }}
        />
    )
}

export default SelectDropDown